import React from 'react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';
import { getFileUrl } from '../utils/fileUtils';

const HeroSection = ({ settings }) => {
  const data = settings || companyInfo;

  const scrollToMachines = () => {
    const element = document.getElementById('machines');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={getFileUrl(data.heroImage) || companyInfo.heroImage}
          alt="Hallstatt Factory"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/40 via-stone-800/30 to-stone-900/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Content Card with backdrop */}
          <div className="backdrop-blur-md border border-white/20 p-8 sm:p-12 rounded-2xl !opacity-[90%] !shadow-2xl bg-white/80">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-stone-900 leading-tight tracking-tight mb-6">
              {data.companyName || data.name}
            </h1>
            
            <div className="h-1 w-32 bg-clay-primary mx-auto mb-6"></div>
            
            <h2 className="text-2xl sm:text-3xl font-semibold text-stone-800 mb-8">
              {data.tagline}
            </h2>
            
            <div className="pt-4">
              <Button
                onClick={scrollToMachines}
                size="lg"
                className="bg-clay-primary hover:bg-clay-dark text-white px-12 py-7 text-xl font-semibold rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105">

                Ver Máquinas
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-white/70 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;